<template>
  <div v-loading="showFlag">
    <t-card>
      <div>
        <!-- 仕入先テーブル -->
        <t-table
          ref="supplierReferenceTable"
          :data="supplierReferenceTable"
          header-cell-class-name="bg-default"
          :height="detailHeight"
          border
        >
          <t-table-column
            type="selection"
            min-width="55"
            align="center"
            header-align="center" />
          <!-- :selectable="selectable"  -->
          <!-- 処理 -->
          <t-table-column
            v-if="type == 'estimateRequestOutput'"
            :label="$t('resource.NUMBER.PROCESSING_KBN')"
            :width="100"
            align="center"
          >
            <template #default="scope"> {{ scope.row.process }}</template>
          </t-table-column>

          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.width"
            :align="column.align"
          >
          </t-table-column
        ></t-table>
        <t-row type="flex" justify="end">
          <!-- 確定ボタン -->
          <div
            v-if="type != 'estimateRequestOutput'"
            :style="{ height: bottomHeight + 'px' }"
          >
            <t-col :span="24">
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                @click="confirmClick"
                >{{ $t("resource.sys.sure") }}</t-button
              >
            </t-col>
          </div>
          <!-- メール送信ボタン と　出力ボタン -->
          <div
            v-if="type == 'estimateRequestOutput'"
            :style="{ height: bottomHeight + 'px' }"
          >
            <t-col :span="24">
              <!-- <t-button
                round
                type="primary"
                class="dialogButton_confirm_120_40"
                ref="sendMailBtn"
                @click="sendMailButtonClick"
                >{{ $t("resource.NUMBER.SEND_MAIL_BUTTON") }}</t-button
              > -->
              <t-button
                round
                type="primary"
                class="dialogButton_confirm_120_40"
                ref="outputBtn"
                @click="outputButtonClick"
                >{{ $t("resource.NUMBER.FILE_OUTPUT_BUTTON") }}</t-button
              >
            </t-col>
          </div>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { httpApi } from "@/api/api";
import { getUserInfo } from "@/auth";
import { t } from "@/locales";
import { outputExcelToZip } from "@/services/common";
import { EditQuoteStateByQuoteNo } from "@/services/number";
import { SearchSupplierInfo } from "@/services/supplierInfo";
import {
  getAbleSupplierInfoList,
  getDialogContentHeight,
} from "@/utils/comFunction";
import { Message, Modal } from "@tellus/component";

import {
  DIALOG_LINE_HEIGHT,
  FACTORY_KBN_DALIAN,
  STR_EMPTY,
} from "@/utils/const";
export default {
  data() {
    return {
      //仕入先テーブル
      supplierReferenceTable: [],

      //仕入先テーブルの列
      columns: [
        {
          prop: "supCode",
          label: t("resource.NUMBER.SUP_CODE"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          align: "left",
        },
        {
          prop: "supName",
          label: t("resource.NUMBER.SUP_NAME"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
          align: "left",
        },
        {
          prop: "supAbbreviation",
          label: t("resource.NUMBER.SUP_ABBREVIATION"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          align: "left",
        },
        {
          prop: "supFactoryKbnStr",
          label: t("resource.NUMBER.SUP_FACTORY_KBN"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          align: "center",
        },
      ],

      //明細情報のheight
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 0,
        DIALOG_LINE_HEIGHT * 1,
        0
      ),
      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,

      data: null,

      nbUpdateTimeLocal: this.nbUpdateTime,

      showFlag: false,
    };
  },
  props: {
    tableIndex: {
      //1:加工 2:処理1 3:処理2 4:処理3
      Type: Number,
      default: 0,
    },
    type: {
      Type: String,
      //supplierSelect:仕入先選択画面  estimateRequestOutput:見積依頼書作成の仕入先選択画面
      default: STR_EMPTY,
    },

    nbQuoteNo: {
      Type: String,
      default: STR_EMPTY,
    },

    //データの更新時刻
    nbUpdateTime: {
      Type: String,
      default: STR_EMPTY,
    },

    //選択された「仕入先」、value: 220、label：仕入先A
    supData: {
      Type: Array,
      default: STR_EMPTY,
    },
    supDataAll: {
      Type: Object,
      default: STR_EMPTY,
    },
  },
  mounted() {
    this.init();
    //列幅に自動調整
    //setColumnWidth(this.columns, this.supplierReferenceTable);
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    // 初期化
    init() {
      this.showFlag = true;
      //検索仕入先マスタ情報
      SearchSupplierInfo()
        .then((res) => {
          //仕入先テーブル
          this.supplierReferenceTable = res;

          this.getAbleList();

          //データ処理
          this.dataProcess();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    // 使用可能な仕入先リストの取得
    getAbleList() {
      // 得意先リスト
      this.supplierReferenceTable = getAbleSupplierInfoList(
        this.supplierReferenceTable,
        null
      );
    },

    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 0,
        DIALOG_LINE_HEIGHT * 1,
        0
      );
    },

    //データ処理
    dataProcess() {
      //「仕入先選択画面」をクリックしてこの画面を開きます。
      if (this.type == "supplierSelect" && this.supData) {
        if (this.tableIndex != 0) {
          //「処理123」の大連工場は表示されない
          this.supplierReferenceTable = this.supplierReferenceTable.filter(
            (sup) => sup.supFactoryKbn != FACTORY_KBN_DALIAN
          );
        }

        this.$nextTick(() => {
          //デフォルトでは、選択した「仕入先」の行が選択されています
          for (var j = 0; j < this.supData.length; j++) {
            for (var i = 0; i < this.supplierReferenceTable.length; i++) {
              if (
                this.supplierReferenceTable[i]["supCode"] == this.supData[j]
              ) {
                this.$refs.supplierReferenceTable.toggleRowSelection(
                  this.supplierReferenceTable[i],
                  true
                );

                break;
              }
            }
          }
        });
      }

      //「見積依頼書出力」をクリックしてこの画面を開きます。「supDataAll」は空ではなく。一覧表のデータはフィルタリングが必要です
      if (this.type == "estimateRequestOutput" && this.supDataAll) {
        var supplierReferenceTableBak = this.supplierReferenceTable;
        this.supplierReferenceTable = [];
        for (var i = 0; i < 4; i++) {
          var tmpArr = supplierReferenceTableBak.filter((item) =>
            this.supDataAll[i].supData.some(
              (supItem) => supItem === item.supCode
            )
          );

          if (tmpArr.length > 0) {
            var process = STR_EMPTY;
            if (i == 0) {
              process = t("resource.NUMBER.MAIN_PROCESSING");
            } else if (i == 1) {
              process = t("resource.NUMBER.PROCESSING_ONE");
            } else if (i == 2) {
              process = t("resource.NUMBER.PROCESSING_TWO");
            } else if (i == 3) {
              process = t("resource.NUMBER.PROCESSING_THREE");
            }

            var newTmpArr = tmpArr.map((item) => ({
              ...item,
              process: process,
              processCode: i,
            }));

            this.supplierReferenceTable.push(newTmpArr);
          }
        }

        this.supplierReferenceTable =
          this.supplierReferenceTable.flat(Infinity);

        this.$nextTick(() => {
          for (var i = 0; i < this.supplierReferenceTable.length; i++) {
            this.$refs.supplierReferenceTable.toggleRowSelection(
              this.supplierReferenceTable[i],
              true
            );
          }
        });
      }
    },

    // selectable(row, index) {
    //   if (this.tableIndex != 0) {
    //     //flagの値に基づいて、その行が選択可能かどうかを決定する
    //     return row.supFactoryKbn != FACTORY_KBN_DALIAN;
    //   } else {
    //     return true;
    //   }
    // },

    //确定ボタン
    confirmClick() {
      this.data = this.$refs.supplierReferenceTable.selection.slice();

      //仕入先コードの小さい順に並べる
      this.data.sort((a, b) => {
        return Number(a.supCode) - Number(b.supCode);
      });

      var result = STR_EMPTY;
      if (this.data.length >= 1) {
        for (var i = 0; i < this.data.length; i++) {
          //[仕入先コード:仕入先略称(貨幣タイプ)]
          result =
            result +
            this.data[i].supCode +
            ":" +
            this.data[i].supAbbreviation +
            "(" +
            this.data[i].supCurrency +
            ");";
        }
        result = result.slice(0, result.lastIndexOf(";"));

        this.$emit("ok", result);
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
    },

    //行データのチェックイベント
    handleSelectionChange(val) {
      //this.data = val;
      this.data = this.SelectedRows;
    },

    //メール送信ボタン
    sendMailButtonClick() {
      // フォーカス削除
      this.$refs.sendMailBtn.$el.blur();

      this.data = this.$refs.supplierReferenceTable.selection;
      if (this.data.length >= 1) {
        // Modal.showInfo("", t("message.confirm.operation"), {
        //   $type: "prompt",
        //   confirmButtonText: t("resource.button.sure"),
        //   cancelButtonText: t("resource.button.cancel"),
        //   showCancelButton: true,
        // }).then(() => {
        this.$message("「メール送信」ボタン");
        // メール送信API
        /*DeleteOrderInfo(this.data).then(() => {
            this.init();
          });*/
        // });
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
    },

    //ファイル出力ボタン
    outputButtonClick() {
      // フォーカス削除
      this.$refs.outputBtn.$el.blur();

      this.data = this.$refs.supplierReferenceTable.selection;

      if (this.data.length >= 1) {
        // Modal.showInfo("", t("message.confirm.operation"), {
        //   $type: "prompt",
        //   confirmButtonText: t("resource.button.sure"),
        //   cancelButtonText: t("resource.button.cancel"),
        //   showCancelButton: true,
        // }).then(() => {
        // ファイル出力API
        /*DeleteOrderInfo(this.data).then(() => {
            this.init();
          });*/
        // });

        let requestdata = this.data.map((data) => ({
          nbQuoteNo: this.nbQuoteNo,
          processCode: data.processCode,
          process: data.process,
          supCode: data.supCode,
          supName: data.supName,
        }));

        //見積依頼書出力
        outputExcelToZip(
          httpApi.OutPutEstimateDependencyExcel,
          requestdata
        ).finally(() => {
          //見積状態の自動変更
          EditQuoteStateByQuoteNo({
            nbQuoteNo: this.nbQuoteNo,
            nbQuoteState: "2",
            user: getUserInfo().UserId,
            nbUpdateTime: this.nbUpdateTimeLocal,
          })
            .then((res) => {
              this.nbUpdateTimeLocal = res;
            })
            .catch((err) => {
              if (err.data != null) {
                Message.showError(
                  t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                );
              } else {
                Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
              }
            });

          this.showFlag = false;
        });
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
    },
  },
};
</script>
<style scoped>
::v-deep .el-table .current-row > td {
  background-color: #b2d8ff;
}
</style>
